export { CompanyInfo as default } from './CompanyInfo';